import React from 'react';
import '../less/gov-list.less';
import leasing_logo from '../img/leasing_logo.svg';
import frp_logo from '../img/frp_logo.svg';
import gov_guarantees_logo from '../img/gov_guarantees_logo.svg';
import apc_logo from '../img/apc_logo.svg';
import eca_logo from '../img/eca_logo.svg';
import kmda_logo from '../img/kmda_logo.svg';
import light_house_logo from '../img/light_house_logo.svg';
import govListItems from '../enums/gov_items.json';
import ProductList from '../../../../../auxiliary-components/shared/ProductList';

export default function template() {
  const page = 'gov-list';

  const imagesMap = {
    leasing_logo,
    frp_logo,
    gov_guarantees_logo,
    apc_logo,
    eca_logo,
    kmda_logo,
    light_house_logo
  };

  const govListData = govListItems.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  return (
    <div className="gov-list">
      <ProductList
        title="GOV_LIST_NEW_TITLE"
        items={govListData}
        page={page}
      />
    </div>
  );
}
